
import { defineComponent } from 'vue';
import EssentialLink from 'src/components/EssentialLink.vue';
import { mapGetters } from 'src/store';

const Sidebar = defineComponent({
  components: { EssentialLink },
  setup() {
    return {
      ...mapGetters('app', ['isLogged', 'isLeftDrawerOpen', 'user']),
    };
  },
});

export default Sidebar;
